// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Xf","closeIcon":"Xbh"};